module.exports = __webpack_public_path__ + "img/Image2.cb0ea9ac.png";